import React from 'react'

export default props => (
  <svg width='12' height='15' {...props} xmlns='http://www.w3.org/2000/svg'>
    <path d='M6 .67a4 4 0 0 0-4 4v.66c-.73 0-1.33.6-1.33 1.34v6.66c0 .74.6 1.34 1.33 1.34h8c.73 0 1.33-.6 1.33-1.34V6.67c0-.74-.6-1.34-1.33-1.34v-.66a4 4 0 0 0-4-4zM6 2a2.61 2.61 0 0 1 2.67 2.67v.66H3.33v-.66A2.61 2.61 0 0 1 6 2zm0 6.67c.73 0 1.33.6 1.33 1.33 0 .73-.6 1.33-1.33 1.33-.73 0-1.33-.6-1.33-1.33 0-.73.6-1.33 1.33-1.33z' />
  </svg>
)
